import { render, staticRenderFns } from "./CommentSection.vue?vue&type=template&id=61a48cae&scoped=true&"
import script from "./CommentSection.vue?vue&type=script&lang=js&"
export * from "./CommentSection.vue?vue&type=script&lang=js&"
import style0 from "./CommentSection.vue?vue&type=style&index=0&id=61a48cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a48cae",
  null
  
)

export default component.exports